import firebase from 'firebase/app'

// Add the Firebase products that you want to use
import 'firebase/auth'
//import 'firebase/database'
import 'firebase/storage'
import 'firebase/firestore'

// Your web app's Firebase configuration
if (process.env.NODE_ENV === 'production') {
  var firebaseConfig = {
    apiKey: 'AIzaSyCmCcCo6QT2B1RSVw_PfRPlvuvaXhIqEg4',
    authDomain: 'northwing-trials-6b959.firebaseapp.com',
    projectId: 'northwing-trials-6b959',
    storageBucket: 'northwing-trials-6b959.firebasestorage.app',
    messagingSenderId: '104683288197',
    appId: '1:104683288197:web:fc86a02091a08530f9dbec',
    measurementId: 'G-35LPCZTENZ'
  }
} else {
  firebaseConfig = {
    apiKey: 'AIzaSyCmCcCo6QT2B1RSVw_PfRPlvuvaXhIqEg4',
    authDomain: 'northwing-trials-6b959.firebaseapp.com',
    projectId: 'northwing-trials-6b959',
    storageBucket: 'northwing-trials-6b959.firebasestorage.app',
    messagingSenderId: '104683288197',
    appId: '1:104683288197:web:fc86a02091a08530f9dbec',
    measurementId: 'G-35LPCZTENZ'
  }
}

// Initialize Firebase
firebase.initializeApp(firebaseConfig)
firebase.auth().useDeviceLanguage()

firebase
  .firestore()
  .enablePersistence()
  .catch(err => {
    if (err.code == 'failed-precondition') {
      // Multiple tabs open, persistence can only be enabled
      // in one tab at a a time.
      // ...
    } else if (err.code == 'unimplemented') {
      // The current browser does not support all of the
      // features required to enable persistence
      // ...
    }
  })

//firebase.analytics()

// firebase utils
const db = firebase.firestore()
const auth = firebase.auth()
const fStore = firebase.storage()
const currentUser = auth.currentUser
const recapt = firebase.auth.RecaptchaVerifier
const provider = firebase.auth.PhoneAuthProvider

export default {
  db,
  auth,
  currentUser,
  fStore,
  provider,
  recapt
}
